import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoaderComponent } from "./components/loader/loader.component";
import { PagetitleComponent } from "./components/pagetitle/pagetitle.component";
import { SafeUrlPipe } from "../core/pipes/safe-url.pipe";
import { SsnDirective } from "./directives/ssn.directive";
import { UploadImageComponent } from "./components/upload-image/upload-image.component";
import { FileUploadModule } from "@iplab/ngx-file-upload";
import { PhonePipe } from "../core/pipes/phone.pipe";
import { DateWithoutTimezonePipe } from "../core/pipes/date-without-timezone.pipe";
import { DobFormatPipe } from "../core/pipes/dob-format.pipe";
import { ScrollSpyDirective } from "./directives/scroll-spy.directive";
import { AutofocusDirective } from "./directives/auto-focus.directive";
import { ReplaceUnderscoreWithSpacePipe } from "../core/pipes/replace-underscore-with-space.pipe";
import { YesNoPipe } from "../core/pipes/yes-no.pipe";
import { SplitCamelCasePipe } from "../core/pipes/split-camel-case.pipe";
import { HtmlPreviewPipe } from "../core/pipes/html-preview.pipe";
import { SafeHtmlPipe } from "../core/pipes/safe-html.pipe";
import { ActivityNoteTagHighlightPipe } from "../core/pipes/activity-note-tag-highlight.pipe";
import { FormatTimeUnitsPipe } from "../core/pipes/format-time-units.pipe";
import { TemplateTypeDisplayPipe } from "../core/pipes/template-type-display.pipe";
import { AuditDisplayNamePipe } from "../core/pipes/audit-display-name.pipe";
import { SessionTimeoutComponent } from "./components/session-timeout/session-timeout";
import { DocumentAttachmentComponent } from "./components/document-attachment/document-attachment.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UploadDocumentModalComponent } from "./components/document-attachment/upload-document-modal/upload-document-modal.component";
import { FileSizePipe } from "../core/pipes/file-size.pipe";
import { DocumentPreviewComponent } from "./components/document-attachment/document-preview/document-preview.component";
import { EmbeddedDocumentPreviewComponent } from "./components/document-attachment/document-preview/embedded-document-preview.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { PatientInfoHeaderComponent } from "./components/patient-info-header/patient-info-header.component";
import { ProgressbarModule } from "ngx-bootstrap/progressbar";
import { ChecklistQuestionsComponent } from "./components/checklist-questions/checklist-questions.component";
import { UploadDocumentComponent } from './components/upload-document/upload-document.component';
import { LabOrderedViewComponent } from './components/upload-document/lab-ordered-view/lab-ordered-view.component';
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { AddActivityModalComponent } from './components/add-activity-modal/add-activity-modal.component';
import { AutosizeModule } from "ngx-autosize";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { CardComponent } from './components/card/card.component';
import { WeekPickerComponent } from './components/week-picker/week-picker.component';
import { TableModule } from "primeng/table";
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { SkeletonModule } from 'primeng/skeleton';
import { TemplateControlsComponent } from './components/template-controls/template-controls.component';
import { VariablePanelComponent } from './components/variable-panel/variable-panel.component';
import { CircularProgressBarComponent } from './components/circular-progress-bar/circular-progress-bar.component';
import { ChatHistoryComponent } from './components/chat-history/chat-history.component';
import { AiChatBotComponent } from './components/ai-chat-bot/ai-chat-bot.component';
import { AyaChatProgressComponent } from './components/ai-chat-bot/aya-chat-progress/aya-chat-progress.component';
import { AyaChatSourcesComponent } from './components/ai-chat-bot/aya-chat-sources/aya-chat-sources.component';
import { AyaChatFollowupsComponent } from './components/ai-chat-bot/aya-chat-followups/aya-chat-followups.component';
import { SmsTimelineComponent } from './components/sms-timeline/sms-timeline.component';
import { SendSmsComponent } from './components/send-sms/send-sms.component';
import { MessageTemplateModalComponent } from './components/message-template-modal/message-template-modal.component';
import { SavedRepliesModalComponent } from './components/saved-replies-modal/saved-replies-modal.component';
import { StageActivityComponent } from './components/stage-activity/stage-activity.component';
import { UnifiedActivityFeedComponent } from './components/unified-activity-feed/unified-activity-feed.component';
import { MediaPreviewModalComponent } from './components/media-preview-modal/media-preview-modal.component';
import { LightPdfPreviewComponent } from './components/light-pdf-preview/light-pdf-preview.component';
import { PdfPreviewComponent } from './components/pdf-preview/pdf-preview.component';
import { MyAppTileComponent } from './components/my-app-tile/my-app-tile.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from "ngx-bootstrap/tooltip";

@NgModule({
  declarations: [
    LoaderComponent,
    PagetitleComponent,
    UploadImageComponent,
    SafeUrlPipe,
    SsnDirective,
    PhonePipe,
    DateWithoutTimezonePipe,
    DobFormatPipe,
    ScrollSpyDirective,
    YesNoPipe,
    AutofocusDirective,
    ReplaceUnderscoreWithSpacePipe,
    SplitCamelCasePipe,
    HtmlPreviewPipe,
    SafeHtmlPipe,
    ActivityNoteTagHighlightPipe,
    FormatTimeUnitsPipe,
    TemplateTypeDisplayPipe,
    SessionTimeoutComponent,
    DocumentAttachmentComponent,
    UploadDocumentModalComponent,
    DocumentPreviewComponent,
    EmbeddedDocumentPreviewComponent,
    FileSizePipe,
    PatientInfoHeaderComponent,
    ChecklistQuestionsComponent,
    UploadDocumentComponent,
    LabOrderedViewComponent,
    AddActivityModalComponent,
    CardComponent,
    WeekPickerComponent,
    DropdownComponent,
    TemplateControlsComponent,
    VariablePanelComponent,
    CircularProgressBarComponent,
    ChatHistoryComponent,
    AiChatBotComponent,
    AyaChatProgressComponent,
    AyaChatSourcesComponent,
    AyaChatFollowupsComponent,
    SmsTimelineComponent,
    SendSmsComponent,
    MessageTemplateModalComponent,
    SavedRepliesModalComponent,
    StageActivityComponent,
    UnifiedActivityFeedComponent,
    MediaPreviewModalComponent,
    LightPdfPreviewComponent,
    MyAppTileComponent,
  ],
  imports: [
    CommonModule,
    AuditDisplayNamePipe,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,
    NgSelectModule,
    ProgressbarModule,
    BsDropdownModule.forRoot(),
    AutosizeModule,
    DragDropModule,
    TableModule,
    DropdownModule,
    CalendarModule,
    SkeletonModule,
    ModalModule,
    TooltipModule,
    PdfPreviewComponent,
  ],
  exports: [
    LoaderComponent,
    PagetitleComponent,
    SafeUrlPipe,
    SsnDirective,
    UploadImageComponent,
    PhonePipe,
    YesNoPipe,
    DateWithoutTimezonePipe,
    DobFormatPipe,
    ScrollSpyDirective,
    AutofocusDirective,
    ReplaceUnderscoreWithSpacePipe,
    SplitCamelCasePipe,
    HtmlPreviewPipe,
    SafeHtmlPipe,
    ActivityNoteTagHighlightPipe,
    FormatTimeUnitsPipe,
    TemplateTypeDisplayPipe,
    AuditDisplayNamePipe,
    SessionTimeoutComponent,
    DocumentAttachmentComponent,
    EmbeddedDocumentPreviewComponent,
    FileSizePipe,
    PatientInfoHeaderComponent,
    ChecklistQuestionsComponent,
    UploadDocumentComponent,
    CardComponent,
    WeekPickerComponent,
    DropdownComponent,
    TemplateControlsComponent,
    VariablePanelComponent,
    CircularProgressBarComponent,
    ChatHistoryComponent,
    AiChatBotComponent,
    SmsTimelineComponent,
    SendSmsComponent,
    StageActivityComponent,
    UnifiedActivityFeedComponent,
    LightPdfPreviewComponent,
    PdfPreviewComponent,
    MyAppTileComponent,
    /** So host modules (e.g. PagesModule) can use `p-dropdown` with ngModel. */
    DropdownModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
